import React, { useEffect } from 'react'
import { loadCaptchaEnginge, LoadCanvasTemplateNoReload } from 'react-simple-captcha'
import Field from '../_library/Field'
import Button from '../_library/Button'

const Captcha = ({ isSubmitting, captchaValue, setCaptchaValue, captchaError, setCaptchaError }) => {
  useEffect(() => {
    loadCaptchaEnginge(6)
  }, [])

  const handleCaptchaChange = e => {
    setCaptchaValue(e.target.value)
    setCaptchaError('')
  }

  const handleCaptchaReload = () => {
    loadCaptchaEnginge(6)
  }

  return (
    <div className="captcha">
      <p>Please complete the captcha to continue with your submission:</p>

      <div className="captchaInner">
        <LoadCanvasTemplateNoReload />
        <Button className="btn btn-default" type="button" onClick={handleCaptchaReload}>
          Reload
        </Button>
      </div>

      <div className="captchaButtonWrapper">
        <Field
          label="Captcha"
          id="captcha"
          value={captchaValue}
          error={captchaError}
          touched={Boolean(captchaError)}
          onChange={handleCaptchaChange}
          disabled={isSubmitting}
        />
      </div>
    </div>
  )
}

export default Captcha
